export const validationRequired = (config) => {
    return Object.assign({ required: true, trigger: 'blur' }, config);
};
